import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as summarizeWrittenTextServices from '@iso/services/writing/summarizeWrittenText';

//#region CRUD
export function* getSummarizeWrittenText() {
	yield takeLatest(actions.GET_SUMMARIZE_WRITTEN_TEXT, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeWrittenTextServices.getSummarizeWrittenText, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_SUMMARIZE_WRITTEN_TEXT_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.WRITING_LOADING_FALSE,
			});
		}
	});
}

export function* getSummarizeWrittenTextDetail() {
	yield takeLatest(actions.GET_SUMMARIZE_WRITTEN_TEXT_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(summarizeWrittenTextServices.getSummarizeWrittenTextDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.WRITING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesSummarizeWrittenText() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_SUMMARIZE_WRITTEN_TEXT, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeWrittenTextServices.createQuesSummarizeWrittenText, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateSummarizeWrittenTextDetail() {
	yield takeLatest(actions.UPDATE_SUMMARIZE_WRITTEN_TEXT_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeWrittenTextServices.updateSummarizeWrittenTextDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteSummarizeWrittenText() {
	yield takeLatest(actions.DELETE_SUMMARIZE_WRITTEN_TEXT, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(summarizeWrittenTextServices.deleteSummarizeWrittenText, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getSummarizeWrittenText),
		fork(getSummarizeWrittenTextDetail),
		fork(createQuesSummarizeWrittenText),
		fork(updateSummarizeWrittenTextDetail),
		fork(deleteSummarizeWrittenText),
	]);
}
